import { ContentSections, useContentBlocks } from '../components/content/ContentSections';
import { StaticPageLayout } from '../components/layout/StaticPageLayout';

const PRIVACY_UPDATED = '2026-10-20';

export function PrivacyPage() {
  const blocks = useContentBlocks('staticPages.privacy.blocks');

  return (
    <StaticPageLayout
      titleKey="staticPages.privacy.title"
      subtitleKey="staticPages.privacy.subtitle"
      lastUpdatedKey="staticPages.privacy.lastUpdated"
      date={PRIVACY_UPDATED}
    >
      <ContentSections blocks={blocks} />
    </StaticPageLayout>
  );
}
